module.exports = __webpack_public_path__ + "static/media/meditate-thumbnail.8918111e.png";